<template>
  <v-card flat>
    <v-card-title>
      <v-list-tile-avatar>
        <v-icon>search</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field
            color="secondary"
            label="Search by Automation Request(AR) number or Business reason"
            v-model="search"
            @change="getItems"
            xs5
          >
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click.stop="clearSearch">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="getItems">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh Automation request history</span>
      </v-tooltip>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="automationRequests"
      item-key="hexId"
      :loading="automationRequestLoading"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="pagination.totalItems"
      expandable
    >
      <v-progress-linear slot="progress" color="accent" indeterminate />
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left" @click="props.expanded = !props.expanded">
            <div class="body-1 font-weight-bold">
              {{ props.item.requestNumber }}
            </div>
            <div class="caption">
              {{ props.item.hexId }}
            </div>
          </td>
          <td class="text-xs-left" @click="props.expanded = !props.expanded">
            <div class="body-1 font-weight-bold">
              {{ props.item.externalRequestedBy }}
            </div>
            <div class="caption">
              {{ props.item.externalId }}
            </div>
          </td>
          <td class="text-xs-left" @click="props.expanded = !props.expanded">
            <div class="body-1 font-weight-bold">
              {{ props.item.businessReason }}
            </div>
          </td>
          <td class="text-xs-left" @click="props.expanded = !props.expanded">
            <div class="body-1 font-weight-bold">
              {{ props.item.requestedByName }}
            </div>
            <div class="caption">
              {{ getLocalTime(props.item.createdAt) }}
            </div>
          </td>
          <td class="text-xs-left" @click="props.expanded = !props.expanded">
            <div :class="props.item.color + '--text body-1 font-weight-bold'">
              {{ props.item.currentStatus }}
            </div>
          </td>
          <td class="text-xs-left">
            <v-btn
              flat
              icon
              :to="{
                name: 'task-report',
                query: { arnumber: props.item.requestNumber }
              }"
            >
              <v-icon>assignment</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-left">
            <v-btn flat icon @click="focusCurrentAR(props.item.hexId)">
              <v-icon>mdi-image-filter-center-focus</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card v-if="props.expanded">
          <!--          <automation-request :request-id="props.item.hexId" />-->
          <automation-request-view :automation-request="props.item" />
        </v-card>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="success" icon="info">
          No Automation request found!
        </v-alert>
      </template>
      <template slot="no-results">
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" not found.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import AutomationRequestView from '@/components/self-service/AutomationRequestView.vue'
import axios from 'axios'
import u from '@/utils'
import _ from 'lodash'

export default {
  name: 'AutomationRequestHistory',
  components: {  AutomationRequestView },
  props: {
    serviceHexId: String
  },
  data: function() {
    return {
      search: '',
      automationRequestLoading: false,
      automationRequests: [],
      rowsPerPage: 0,
      descending: false,
      sortBy: '',
      currentPage: 0,
      pagination: {
        page: 1,
        rowsPerPage: 5,
        sortBy: 'createdAt',
        descending: true,
        totalItems: 0
      },
      current: {
        page: 1,
        rowsPerPage: 5,
        sortBy: 'createdAt',
        descending: true
      },
      rowsPerPageItems: [5, 10, 25],
      headers: [
        {
          text: 'AR Number / Internal Id',
          align: 'left',
          value: 'requestNumber'
        },
        {
          text: 'External Requested By / External Id',
          align: 'left',
          value: 'externalRequestedBy'
        },
        { text: 'Business Reason', value: 'businessReason', sortable: false },
        { text: 'Requested By / Requested At', value: 'createdAt' },
        { text: 'Status', value: 'serviceStatus' },
        { text: 'Show relevant Tasks', value: 'Action' },
        { text: 'Focus', value: 'Action' }
      ]
    }
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.current.page ||
            this.pagination.rowsPerPage !== this.current.rowsPerPage ||
            this.pagination.sortBy !== this.current.sortBy ||
            this.pagination.descending !== this.current.descending
          ) {
            this.current.page = this.pagination.page
            this.current.rowsPerPage = this.pagination.rowsPerPage
            this.current.sortBy = this.pagination.sortBy
            this.current.descending = this.pagination.descending
            this.getItems()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    }
  },
  mounted() {
    this.getItems()
  },
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getLocalTime(input) {
      return moment(input)
        .utc()
        .local()
        .format('DD MMM YYYY, hh:mm:ss a')
    },
    focusCurrentAR(hexId) {
      this.$router
        .push({
          name: 'automation-request',
          params: { hexId: hexId }
        })
        .catch()
    },
    getUrlParams() {
      let urlParams = ''
      //fill URL Params from current structure

      urlParams += `&page=${this.current.page}`
      urlParams += `&size=${this.current.rowsPerPage}`
      if (this.current.sortBy) {
        urlParams += `&sort=${this.current.sortBy}`
        if (this.current.descending) {
          urlParams += `,desc`
        }
      }
      if (this.search) {
        urlParams = urlParams + `&search=${this.search}`
      }
      return urlParams
    },
    clearSearch() {
      this.search = ''
      this.getItems()
    },
    getItems() {
      if (this.serviceHexId) {
        this.automationRequestLoading = true
        const urlParams = this.getUrlParams()

        axios
          .get(
            `/api/v1/automationRequests/byService/${this.serviceHexId}?projection=withServiceStatus&${urlParams}`
          )
          .then(response => {
            if (response.data._embedded) {
              this.pagination.totalItems = response.data.page.totalElements
              let automationRequests = [
                ...response.data._embedded.automationRequests
              ]
              this.automationRequests = automationRequests.map(obj => {
                obj.requestNumber = 'AR' + obj.requestNumber
                switch (obj.serviceStatus) {
                  case 'RAISED':
                    obj.color = 'error'
                    obj.icon = 'error'
                    obj.currentStatus = 'Request raised (Not processed)'
                    obj.errorStatus = true
                    break
                  case 'RECEIVED':
                    obj.color = 'info'
                    obj.icon = 'done'
                    obj.currentStatus = 'Request received'
                    obj.errorStatus = false
                    break
                  case 'SERVICED':
                    obj.color = 'success'
                    obj.icon = 'done_all'
                    obj.currentStatus = 'Request serviced'
                    obj.errorStatus = false
                    break
                  case 'IN_PROGRESS':
                    obj.color = 'info'
                    obj.icon = 'directions_run'
                    obj.currentStatus = 'Request being serviced'
                    obj.errorStatus = false
                    break
                  case 'AWAITING_USER_INPUTS':
                    obj.color = 'info'
                    obj.icon = 'mdi-approval'
                    obj.currentStatus = 'Request waiting for user approval'
                    obj.errorStatus = false
                    break
                  case 'OBSOLETE':
                    obj.color = 'error'
                    obj.icon = 'archive'
                    obj.currentStatus = 'Request failed'
                    obj.errorStatus = true
                    break
                  case 'FAILED':
                    obj.color = 'error'
                    obj.icon = 'error'
                    obj.currentStatus = 'Request failed'
                    obj.errorStatus = true
                    break
                  default:
                    obj.color = 'error'
                    obj.icon = 'error'
                    obj.currentStatus = 'Not processed'
                    obj.errorStatus = true
                    break
                }
                return obj
              })
              this.automationRequestLoading = false
            } else {
              this.automationRequestLoading = false
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.dispatch('directNotification', {
              type: 'error',
              message: 'Unable to retrieve Automation request',
              description: e.response
                ? e.response.data.message
                : 'Error unknown! Kindly retry',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
            this.automationRequestLoading = false
          })
      }
    }
  }
}
</script>

<style scoped></style>
